/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Changelog_LedeInputs */

const en_marketing_changelog_lede = /** @type {(inputs: Marketing_Changelog_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onyx is the foundation JXD builds on, so it improves whenever the work does. Every drop lands here.`)
};

const es_marketing_changelog_lede = /** @type {(inputs: Marketing_Changelog_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onyx es la base sobre la que construye JXD, así que mejora cada vez que avanza el trabajo. Cada entrega aparece aquí.`)
};

const fr_marketing_changelog_lede = /** @type {(inputs: Marketing_Changelog_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onyx est la fondation sur laquelle JXD construit : elle progresse dès que le travail avance. Chaque livraison atterrit ici.`)
};

/**
* | output |
* | --- |
* | "Onyx is the foundation JXD builds on, so it improves whenever the work does. Every drop lands here." |
*
* @param {Marketing_Changelog_LedeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_changelog_lede = /** @type {((inputs?: Marketing_Changelog_LedeInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Changelog_LedeInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_changelog_lede(inputs)
	if (locale === "es") return es_marketing_changelog_lede(inputs)
	return fr_marketing_changelog_lede(inputs)
});